// method which returns a unique array of objects
export const getUniqueArray = (array: Array<any>, propName: string) => {
  return array.filter((v, i, a) => a.findIndex(v2 => v2[propName] === v[propName]) === i);
};
